import Menu from './menu.container';

export default Menu;
